<div style="min-height: 600px">
  <ngx-charts-bar-vertical-2d
    [animations]="enabledAnimations"
    [barPadding]="barPadding"
    [roundEdges]="roundEdges"
    [scheme]="colorScheme"
    [results]="chartData"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [rotateXAxisTicks]="rotateXAxisTicks"
    [legend]="showLegend"
    [legendPosition]="legendPosition"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [legendTitle]="legendTitle"
    (select)="onSelect($event)"
    (activate)="onActivate($event)"
    (deactivate)="onDeactivate($event)"
  >
  </ngx-charts-bar-vertical-2d>
</div>
